import React, { useContext, useEffect } from 'react';
import './index.css';
import { Switch, useHistory } from 'react-router-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import { makeStyles } from '@material-ui/core/styles';
import NavBar from '../atoms/NavBar';
import Routes from '../routes/routes';
import { AuthenticationContext } from '../contexts/Authentication';
import ProtectedRoute from '../atoms/ProtectedRoute';
import { LicenseInfo } from '@material-ui/x-grid'

LicenseInfo.setLicenseKey('22231c561b53b72afad7dc6ca1950179T1JERVI6MTc5MTcsRVhQSVJZPTE2MzM3ODA4MzEwMDAsS0VZVkVSU0lPTj0x');

const NavBarWidth = 220;

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flex: 1,
    height: '100vh'
  },
  drawerPaper: {
    width: NavBarWidth,
  },
  content: {
    display: 'flex',
    flex: 1,
    padding: 16
  },
}));

const App = () => {
  const classes = useStyles();
  const authentication = useContext(AuthenticationContext);
  const history = useHistory();
  
  const createRoutes = (isLogged: boolean): any[] => {
    const routes = [] as any[];
    Routes.forEach((route) => {
      if (!route.nested) {
        if ((route.protected && isLogged) || (!route.protected && !isLogged)) {
          routes.push(route);
        }
      } else {
        route.nested.forEach((subroute) => {
          if ((route.protected && isLogged) || (!route.protected && !isLogged)) {
            routes.push(subroute);
          }
        });
      }
    });
    return routes;
  }

  useEffect(() => {
    if (!authentication.isLogged) {
      history.push('/login');
    }
  }, [])

  return (
    <div className={classes.root}>
      <CssBaseline />
      {authentication.isLogged && <NavBar width={NavBarWidth} />}
      <div className={classes.content}>
        <Switch>
          {createRoutes(authentication.isLogged).map((r, i) => <ProtectedRoute {...r} key={i} />)}
        </Switch>
      </div>
    </div>
  );
}

export default App;
